
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5CXR9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $432693952a33cf30$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $432693952a33cf30$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': "Annull\xe9r",
    'fabric.linkPicker.button.insert': "Inds\xe6t",
    'fabric.linkPicker.button.save': 'Gem',
    'fabric.linkPicker.clearLink': 'Ryd',
    'fabric.linkPicker.clearLinkText': 'Ryd tekst',
    'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {ingen resultater fundet} one {Der blev fundet {count,number} resultat} other {Der blev fundet {count,number} resultater}}',
    'fabric.linkPicker.linkAriaLabel': "Skriv eller inds\xe6t et link i feltet",
    'fabric.linkPicker.linkHelperTextAriaLabel': "Hj\xe6lpetekst til linkvisning",
    'fabric.linkPicker.linkHelperTextLabel': 'Giv dette link en titel eller beskrivelse',
    'fabric.linkPicker.linkInvalid': 'Indtast en gyldig URL-adresse.',
    'fabric.linkPicker.linkLabel': 'Link',
    'fabric.linkPicker.linkPlaceholder': "Inds\xe6t et link",
    'fabric.linkPicker.linkTextAriaLabel': 'Visningstekst til link',
    'fabric.linkPicker.linkTextLabel': 'Visningstekst (valgfrit)',
    'fabric.linkPicker.linkTextPlaceholder': 'Tekst, der skal vises',
    'fabric.linkPicker.listTitle.recentlyViewed': 'Set for nylig',
    'fabric.linkPicker.listTitle.results': 'Resultater',
    'fabric.linkPicker.search.error.description': 'Opdater siden, eller kontakt <a>Atlassian-support</a>, hvis det bliver ved med at ske.',
    'fabric.linkPicker.search.error.heading': "Vi har problemer med at indl\xe6se data.",
    'fabric.linkPicker.search.error.retry': 'Opdater',
    'fabric.linkPicker.search.linkAriaLabel': "Der vises forslag nedenfor, n\xe5r du skriver i feltet",
    'fabric.linkPicker.search.linkLabel': "S\xf8g efter eller inds\xe6t et link",
    'fabric.linkPicker.search.linkPlaceholder': "Find de seneste links, eller inds\xe6t et nyt link",
    'fabric.linkPicker.search.noResults.description': "Pr\xf8v igen med et andet ord.",
    'fabric.linkPicker.search.noResults.heading': "Vi kunne ikke finde noget, der opfylder dine s\xf8gekriterier.",
    'fabric.linkPicker.status.submitting': 'Indsender',
    'fabric.linkPicker.time.message.updated': 'Opdateret {time}',
    'fabric.linkPicker.time.message.viewed': 'Vist {time}',
    'fabric.linkPicker.unhandledError.description': "Pr\xf8v at genindl\xe6se siden.",
    'fabric.linkPicker.unhandledError.heading': 'Noget gik galt!'
};

});


//# sourceMappingURL=da.2757cc56.js.map
